<div class="panel_wrapper">
  <div class="d-flex flex-row justify-content-between mt-2">
    <button class="create_btn w_45 mt-0" (click)="createNew()">{{ 'VENUE.CREATE_NEW' | translate}}</button>
    <button class="btn_without_color w_45 m-0" (click)="continue()">{{ 'VENUE.CONTINUE' | translate }}</button>
  </div>
</div>
